/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBalanceUpdateRequest {
    getFixupPrototypeFunction() { return MasterAccountBalanceUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBalanceUpdateRequest>): MasterAccountBalanceUpdateRequest {
        let obj = Object.assign(new MasterAccountBalanceUpdateRequest(), model);
        MasterAccountBalanceUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBalanceUpdateRequest>): MasterAccountBalanceUpdateRequest {
        if (!model) return null;
        return MasterAccountBalanceUpdateRequest.newInstance(<MasterAccountBalanceUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBalanceUpdateRequest) {
        if (!obj) return;

        models.MasterAccountBalanceUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBalanceUpdateRequest): boolean {
        Object.setPrototypeOf(obj, MasterAccountBalanceUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    /**
     * Balance amount to updated for the master account
     */
    amount: number;

    /**
     * Transaction id for the balance update
     */
    transaction_id: string;

    /**
     * Name of the user who made the balance update.
     */
    user_name: string;

    /**
     * Id of the tenant where the balance is updated.
     */
    tenant_id: string;

    /**
     * Id of conversation where the balance is updated.
     */
    conversation_id: string;

    /**
     * Type of billing transaction.
     */
    transaction_type: models.BillingTransactionType;

}
